import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetNetworkPlans = ({ networkId: propsNetworkId, disabled = false } = {}) => {
  const { networkId: paramNetworkId } = useParams();
  const networkId = paramNetworkId || propsNetworkId;

  const query = useApiQuery({
    queryKey: keys.networkPlans(networkId),
    requestUrl: `/networks/${networkId}/plans`,
    disabled: !networkId || disabled,
  });

  return {
    plans: query.data?.availablePlans,
    currentPlan: query.data?.currentPlan,
    planOwner: query.data?.planOwner,
    plansError: query.error,
    isPlansFetchError: query.isError,
    isPlansFetchSuccess: query.isSuccess,
    isPlansFetching: query.isFetching,
    isPlansLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetNetworkPlans;
